export default "__VITE_ASSET__fc6a924f__"